const translations = {
    es: {
      developer: "Desarrollador Full Stack",
      specialized: "Especializado en Front End",
      aboutMe: "Acerca de mí",
      hello: "Hola, soy Santiago Alegre, un desarrollador Full Stack con especialización en Front End. Me enfoco en crear interfaces de usuario atractivas y funcionales utilizando tecnologías modernas. Tengo un nivel de inglés C2, lo que me permite comunicarme con fluidez y comprender documentación técnica.",
      certificate: "Podés ver mi certificado acá",
      live: "Vivo en Buenos Aires, Argentina.",
      projects: "Mis Proyectos",
      connect: "Conectá conmigo",
      viewProject: "Ver Proyecto",
    },
    en: {
      developer: "Full Stack Developer",
      specialized: "Specialized in Front End",
      aboutMe: "About Me",
      hello: "Hi, I am Santiago Alegre, a Full Stack developer with a specialization in Front End. I focus on creating attractive and functional user interfaces using modern technologies. I have a C2 level of English, which allows me to communicate fluently and understand technical documentation.",
      certificate: "You can view my certificate here",
      live: "I live in Buenos Aires, Argentina.",
      projects: "My Projects",
      connect: "Connect with me",
      viewProject: "View Project",
    },
  };
  
  export default translations;
  